import { render, staticRenderFns } from "./ChatPopup.vue?vue&type=template&id=f9d0560c&scoped=true"
import script from "./ChatPopup.vue?vue&type=script&lang=js"
export * from "./ChatPopup.vue?vue&type=script&lang=js"
import style0 from "./ChatPopup.vue?vue&type=style&index=0&id=f9d0560c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d0560c",
  null
  
)

export default component.exports